var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Wistia = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.time()
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    if (this.flags.isPaused) return 0
    return this.playrate || this.player.playbackRate()
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.duration()
  },

  /** Override to return rendition */
  getRendition: function () {
    return this.player.selectedQuality()
  },

  /** Override to return title */
  getTitle: function () {
    return this.player.name()
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return false
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.hashedId()
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return this.player.playerType
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'Wistia'
  },

  /** Register listeners to this.player. */
  registerListeners: function () {

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, true)

    // References
    this.references = []
    this.references['play'] = this.playListener.bind(this)
    this.references['pause'] = this.pauseListener.bind(this)
    this.references['end'] = this.endListener.bind(this)
    this.references['timechange'] = this.timechangeListener.bind(this)
    this.references['playbackratechange'] = this.playrateListener.bind(this)

    // Register listeners
    for (var key in this.references) {
      this.player.bind(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.unbind(key, this.references[key])
      }
      this.references = []
    }
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    if (!this.flags.isStarted) {
      this.playrate = null
      this.fireStart()
    }
    this.fireResume()
  },

  /** Listener for 'timechange' event. */
  timechangeListener: function (e) {
    if (this.getPlayhead() > 0) {
      this.fireJoin()
    }
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'end' event. */
  endListener: function (e) {
    this.fireStop()
  },

  playrateListener: function (e) {
    this.playrate = e
  }
})

module.exports = youbora.adapters.Wistia
